import { defineFeature, defineModule, definePermission } from '@shared/contract'
import { EINVOICE_FEATURE } from './contract/common'

// E-Rechnung (docs/erechnung/SPEZIFIKATION.md): XRechnung beim Festschreiben ausstellen, unveränderlich ablegen,
// herunterladen und als übermittelt markieren; eingehende E-Rechnungen einlesen und prüfen (AP6).
//
// Das Modul ist IMMER aktiv (kein requiresFeature): Finanzen rufen die Vorprüfung im Rechnungslauf auf und hängen
// künftig an diesem Modul (AP4) – ein abgeschaltetes Modul legte sonst die Finanzen still. Der Funktionsschalter
// `einvoice` entscheidet, ob beim Festschreiben XML entsteht (§4.1); ohne ihn meldet die Vorprüfung „nicht nötig“.
// Pfand & Leergut ist ein Branchenmodul – deshalb nur optionalDependsOn (sonst wäre die E-Rechnung bei Betrieben
// ohne Pfand aus).
//
// Rechte (§10.2): Ausgehendes Lesen nutzt bewusst die Rechte der Finanzen (`finance.invoice.read`/`.write`) – wer die
// Rechnung sieht, sieht ihre XML. Eigene Rechte: nachträglich ausstellen (je Standort), Eingang lesen, hochladen und
// bearbeiten, Einstellungen (betriebsweit).
const GROUP = 'E-Rechnung'

export default defineModule({
  id: 'einvoice',
  title: 'E-Rechnung',
  description:
    'XRechnung (UBL oder CII) beim Festschreiben von Rechnungen ausstellen, unveränderlich ablegen und herunterladen; E-Rechnungen von Lieferanten einlesen und prüfen.',
  dependsOn: ['platform', 'masterdata', 'purchasing', 'sales'],
  optionalDependsOn: ['deposits'],
  features: [
    defineFeature({
      key: EINVOICE_FEATURE,
      label: 'E-Rechnung',
      description:
        'Beim Festschreiben von Rechnungen und Rechnungskorrekturen entsteht eine XRechnung, wenn die gesetzliche Pflicht, der Wunsch des Kunden oder eine Leitweg-ID es verlangt.',
      defaultEnabled: false,
      // ausgewertet in server/outbound.ts (Festschreiben, nachträgliche Ausgabe) und in der Vorprüfung des Rechnungslaufs
      effect:
        'Eingeschaltet entsteht beim Festschreiben von Rechnungen, Rechnungskorrekturen und deren Storno eine XRechnung, wo Pflicht, Wunsch des Kunden oder Leitweg-ID es verlangen. Ausgeschaltet entsteht keine – auch nicht nachträglich; Eingang und vorhandene E-Rechnungen bleiben erreichbar.',
    }),
  ],
  permissions: [
    definePermission({
      key: 'einvoice.outbound.issue',
      label: 'E-Rechnung nachträglich ausstellen',
      group: GROUP,
      description:
        'Für eine schon festgeschriebene Rechnung ohne XML (vor dem Einschalten oder auf Wunsch) einmal eine XRechnung ausstellen.',
    }),
    definePermission({
      key: 'einvoice.inbound.read',
      label: 'Eingegangene E-Rechnungen lesen',
      group: GROUP,
      locationScoped: false,
    }),
    definePermission({
      key: 'einvoice.inbound.import',
      label: 'E-Rechnungen von Lieferanten hochladen',
      group: GROUP,
      locationScoped: false,
    }),
    definePermission({
      key: 'einvoice.inbound.process',
      label: 'Eingegangene E-Rechnungen zuordnen, erfassen und ablehnen',
      group: GROUP,
      locationScoped: false,
    }),
    definePermission({
      key: 'einvoice.settings',
      label: 'Einstellungen der E-Rechnung ändern',
      group: GROUP,
      description: 'Standard-Syntax (UBL/CII), Stichtag der Ausstellungspflicht und Kleinbetragsgrenze.',
      locationScoped: false,
    }),
  ],
})
